// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemShare_container__3uv3B","txt":"ItemShare_txt__1IiwC","list":"ItemShare_list__2LM4q","btn":"ItemShare_btn__2wTTt"};